exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle {\n  display: none; }\n\n.expandable .toggle {\n  display: inline-block; }\n\n.expandable .content {\n  max-height: 83px;\n  overflow: hidden; }\n\n.expandable.expanded .content {\n  max-height: inherit;\n  overflow: hidden; }\n\n.toggle {\n  cursor: pointer;\n  color: #508dd2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/show-more/show-more.component.scss
// module id = ../../../../../src/app/components/show-more/show-more.component.scss
// module chunks = main